import { createSlice } from '@reduxjs/toolkit';
import { VideoQuality } from 'livekit-client';
import { ColumnCameraPosition, ColumnCameraWidth, VideoObjectFit, } from './interfaces/roomSettings';
const initialState = {
    isShowRoomSettingsModal: false,
    isShowKeyboardShortcuts: false,
    audioDevices: [],
    videoDevices: [],
    selectedAudioDevice: '',
    selectedVideoDevice: '',
    playAudioNotification: false,
    activateWebcamsView: true,
    activeScreenSharingView: true,
    allowPlayAudioNotification: true,
    roomAudioVolume: 1,
    roomScreenShareAudioVolume: 1,
    roomVideoQuality: VideoQuality.HIGH,
    theme: 'light',
    videoObjectFit: VideoObjectFit.CONTAIN,
    selectedTabLeftPanel: 0,
    selectedChatOption: 'public',
    initiatePrivateChat: {
        name: '',
        userId: '',
    },
    unreadMsgFrom: [],
    refreshWebcams: 0,
    columnCameraWidth: ColumnCameraWidth.FULL_WIDTH,
    columnCameraPosition: ColumnCameraPosition.LEFT,
    visibleHeader: true,
    visibleFooter: true,
};
const roomSettingsSlice = createSlice({
    name: 'room-settings',
    initialState,
    reducers: {
        updateShowRoomSettingsModal: (state, action) => {
            state.isShowRoomSettingsModal = action.payload;
        },
        updateShowKeyboardShortcutsModal: (state, action) => {
            state.isShowKeyboardShortcuts = action.payload;
        },
        addAudioDevices: (state, action) => {
            state.audioDevices = action.payload;
        },
        addVideoDevices: (state, action) => {
            state.videoDevices = action.payload;
        },
        updateSelectedAudioDevice: (state, action) => {
            state.selectedAudioDevice = action.payload;
        },
        updateSelectedVideoDevice: (state, action) => {
            state.selectedVideoDevice = action.payload;
        },
        updatePlayAudioNotification: (state, action) => {
            state.playAudioNotification = action.payload;
        },
        updateActivateWebcamsView: (state, action) => {
            state.activateWebcamsView = action.payload;
        },
        updateActiveScreenSharingView: (state, action) => {
            state.activeScreenSharingView = action.payload;
        },
        updateAllowPlayAudioNotification: (state, action) => {
            state.allowPlayAudioNotification = action.payload;
        },
        updateRoomAudioVolume: (state, action) => {
            state.roomAudioVolume = action.payload;
        },
        updateRoomScreenShareAudioVolume: (state, action) => {
            state.roomScreenShareAudioVolume = action.payload;
        },
        updateRoomVideoQuality: (state, action) => {
            state.roomVideoQuality = action.payload;
        },
        updateTheme: (state, action) => {
            state.theme = action.payload;
        },
        updateVideoObjectFit: (state, action) => {
            state.videoObjectFit = action.payload;
        },
        updateSelectedTabLeftPanel: (state, action) => {
            state.selectedTabLeftPanel = action.payload;
        },
        updateSelectedChatOption: (state, action) => {
            state.selectedChatOption = action.payload;
        },
        updateInitiatePrivateChat: (state, action) => {
            state.initiatePrivateChat = action.payload;
        },
        updateUnreadMsgFrom: (state, action) => {
            const tmp = [...state.unreadMsgFrom];
            if (action.payload.task === 'ADD') {
                const exist = tmp.filter((id) => id === action.payload.id);
                if (!exist.length) {
                    tmp.push(action.payload.id);
                    state.unreadMsgFrom = tmp;
                }
            }
            else if (action.payload.task === 'DEL') {
                state.unreadMsgFrom = tmp.filter((id) => id !== action.payload.id);
            }
        },
        doRefreshWebcams: (state) => {
            state.refreshWebcams = Date.now();
        },
        updateColumnCameraWidth: (state, action) => {
            state.columnCameraWidth = action.payload;
        },
        updateColumnCameraPosition: (state, action) => {
            state.columnCameraPosition = action.payload;
        },
        toggleHeaderVisibility: (state) => {
            state.visibleHeader = !state.visibleHeader;
        },
        toggleFooterVisibility: (state) => {
            state.visibleFooter = !state.visibleFooter;
        },
        updateAzureTokenInfo: (state, action) => {
            state.azureTokenInfo = action.payload;
        },
        cleanAzureToken: (state) => {
            if (state.azureTokenInfo) {
                state.azureTokenInfo.token = '';
            }
        },
    },
});
export const { addAudioDevices, addVideoDevices, updateSelectedAudioDevice, updateSelectedVideoDevice, updatePlayAudioNotification, updateShowRoomSettingsModal, updateActivateWebcamsView, updateActiveScreenSharingView, updateAllowPlayAudioNotification, updateShowKeyboardShortcutsModal, updateRoomAudioVolume, updateRoomScreenShareAudioVolume, updateRoomVideoQuality, updateTheme, updateVideoObjectFit, updateSelectedTabLeftPanel, updateSelectedChatOption, updateInitiatePrivateChat, updateUnreadMsgFrom, doRefreshWebcams, updateColumnCameraWidth, updateColumnCameraPosition, toggleHeaderVisibility, toggleFooterVisibility, updateAzureTokenInfo, cleanAzureToken, } = roomSettingsSlice.actions;
export default roomSettingsSlice.reducer;
